import { createContext, useContext, useState } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X, ArrowUpRight } from "lucide-react";
import { HEART } from "./Donate";

const DonateContext = createContext(() => {});
export const useDonate = () => useContext(DonateContext);

const ZeffyMark = () => <svg viewBox="0 0 24 24" fill="currentColor"><path d={HEART} /></svg>;
const SquareMark = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6"><rect x="3" y="3" width="18" height="18" rx="4.5" /><rect x="8.6" y="8.6" width="6.8" height="6.8" rx="1.2" fill="currentColor" stroke="none" /></svg>
);
const PayPalMark = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8.3 21H4.6a.6.6 0 0 1-.6-.7L6.6 3.6c.1-.4.4-.6.8-.6h6.3c3.6 0 5.6 1.8 5.1 4.9-.6 3.7-3 5.4-6.6 5.4H10l-1.1 7.1a.6.6 0 0 1-.6.6z" /><path d="M19.7 8.2c.9.9 1.2 2.2.9 3.8-.6 3.5-2.9 5.1-6.3 5.1h-1.6l-.8 4.4a.6.6 0 0 1-.6.5H8.9l.2-1.3h1.6l1.1-6.9h2c3.9 0 6.5-1.9 7.1-5.9l-1.2.3z" opacity=".55" /></svg>
);

const OPTIONS = [
  { key: "zeffy", name: "Zeffy", note: "Our main donation form. Card, Apple Pay, or Google Pay.", url: "https://www.zeffy.com/en-US/donation-form/donate-to-change-lives-24743", bg: "#5A2D9C", Mark: ZeffyMark },
  { key: "square", name: "Square", note: "Fast and secure checkout with any major card.", url: "https://square.link/u/SpNWWsY9", bg: "#1C1430", Mark: SquareMark },
  { key: "paypal", name: "PayPal", note: "Give with your PayPal balance, bank, or card.", url: "https://www.paypal.com/ncp/payment/RNZYATN2ZEK6J", bg: "#003087", Mark: PayPalMark },
];

const DonateModal = ({ open, onOpenChange }) => (
  <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="donate-overlay" onClick={() => onOpenChange(false)} data-testid="donate-modal-overlay" />
      <DialogPrimitive.Content className="donate-modal" aria-describedby="donate-modal-desc" data-testid="donate-modal">
        <DialogPrimitive.Close className="donate-modal-x" aria-label="Close" data-testid="donate-modal-close-button"><X /></DialogPrimitive.Close>
        <div className="donate-modal-head">
          <span className="donate-modal-heart"><ZeffyMark /></span>
          <DialogPrimitive.Title className="donate-modal-title" data-testid="donate-modal-title">Choose how to donate</DialogPrimitive.Title>
          <DialogPrimitive.Description id="donate-modal-desc" className="donate-modal-desc">
            Every gift helps a neighbor find their way forward. Pick the option that works best for you. Each one opens securely in a new tab.
          </DialogPrimitive.Description>
        </div>
        <ul className="donate-options">
          {OPTIONS.map(({ key, name, note, url, bg, Mark }) => (
            <li key={key}>
              <a href={url} target="_blank" rel="noopener noreferrer" className="donate-option" data-testid={`donate-option-${key}`}>
                <span className="donate-option-ico" style={{ background: bg }}><Mark /></span>
                <span className="donate-option-txt"><b>Donate with {name}</b><small>{note}</small></span>
                <ArrowUpRight className="donate-option-arrow" />
              </a>
            </li>
          ))}
        </ul>
        <p className="donate-modal-foot">Thank you for supporting Davis Infinite Care Corporation.</p>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  </DialogPrimitive.Root>
);

export const DonateProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <DonateContext.Provider value={() => setOpen(true)}>
      {children}
      <DonateModal open={open} onOpenChange={setOpen} />
    </DonateContext.Provider>
  );
};
